import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-vision-ksa',
  templateUrl: './add-vision-ksa.component.html',
  styleUrls: ['./add-vision-ksa.component.scss']
})
export class AddVisionKsaComponent implements OnInit {

  public pages: any;
  public tempData = [];
  public totalItems = 0;
  previewUrl: string | null = null;

  // ✅ هيكل البيانات يدعم ثنائي اللغة
  formData: any = {
    title_ar: '',
    title_en: '',
    description_ar: '',
    description_en: '',
    icon: null as File | string | null,
  }; 

  InvestorsId: any;
  
  constructor(
    private router: Router,
    private apisService: ApisService,
    private toastr: ToastrService,
    public _translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.getTags();
    this.getInvestorsId(); 
  }

  // ✅ دالة مساعدة: هل نعرض الأيقونة الحالية؟ (تجنب typeof في HTML)
  get showCurrentIcon(): boolean {
    return !!this.formData.icon && 
           typeof this.formData.icon === 'string' && 
           !this.previewUrl;
  }
 
  // Handle PDF selection
  onPdfSelected(event: any): void {
    if (event.target.files.length > 0) {
      this.formData.pdf = event.target.files[0];
    }
  }

  getTags() {
    this.apisService.contractsType().subscribe({
      next: (response: any) => {
        this.pages = response.data || [];
        this.totalItems = this.pages.length;
        console.log('pages:', this.pages);
      },
      error: (error: any) => {
        console.error('Error fetching contract types:', error);
      }
    });
  }

  cancel(): void {
    this.router.navigate(['/vision-ksa']);
  }
  
  getTranslation(translations: any[], locale: string) {
    return translations.find(translation => translation.locale === locale) || {};
  }

  getInvestorsId(){ 
    this.apisService.investors().subscribe({
      next: (response: any) => {
        this.InvestorsId = response.data;  
        console.log("InvestorsId:", this.InvestorsId);
      },
      error: (error: any) => {
        console.log(error);
      }
    });
  }

  // 🖼️ اختيار صورة الأيقونة
  onFileSelected(event: any): void {
    if (event.target.files?.length > 0) {
      const file = event.target.files[0];
      this.formData.icon = file;
      this.previewLogo(file);
    }
  }

  // معاينة الصورة
  previewLogo(file: File): void {
    const reader = new FileReader();
    
    reader.onload = (e: any) => {
      this.previewUrl = e.target.result;
    };
    
    reader.onerror = (error) => {
      console.error('Error previewing image:', error);
      this.toastr.error('Error loading image preview');
    };
    
    reader.readAsDataURL(file);
  }

  // إزالة الصورة الحالية
  removeCurrentLogo(): void {
    this.formData.icon = null;
    this.previewUrl = null;
  }

  // إزالة الصورة الجديدة المختارة
  removeNewLogo(): void {
    this.previewUrl = null;
    if (!(this.formData.icon instanceof File)) {
      this.formData.icon = null;
    }
    const fileInput = document.getElementById('logoUpload') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }

  // ✅ إرسال النموذج مع البيانات ثنائية اللغة
  onSubmit() {
    // التحقق من الحقول المطلوبة
    if (!this.formData.title_ar || !this.formData.title_en || 
        !this.formData.description_ar || !this.formData.description_en) {
      this.toastr.error(this._translateService.instant('MENU.DASHBOARD.all_fields_required'));
      return;
    }

    const form = new FormData();

    // 📝 إرسال الحقول ثنائية اللغة
    form.append('title_ar', this.formData.title_ar.trim());
    form.append('title_en', this.formData.title_en.trim());
    form.append('description_ar', this.formData.description_ar.trim());
    form.append('description_en', this.formData.description_en.trim());

    // 🖼️ إرسال الأيقونة إذا كانت ملفاً
    if (this.formData.icon instanceof File) {
      form.append('icon', this.formData.icon);
    }

    this.apisService.addVision(form).subscribe({
      next: (response: any) => {
        console.log('Added successfully:', response);
        this.toastr.success(this._translateService.instant('MENU.DASHBOARD.updated_successfully'));
        this.resetForm();
        this.router.navigate(['/vision-ksa']);
      },
      error: (error: any) => {
        console.error('Error adding vision:', error);

        if (error.error?.errors) {
          const errors = error.error.errors;
          Object.keys(errors).forEach((key) => {
            this.toastr.error(errors[key][0]);
          });
        } else {
          this.toastr.error(this._translateService.instant('MENU.DASHBOARD.something_went_wrong'));
        }
      },
    });
  }

  // 🔄 إعادة تعيين النموذج
  resetForm() {
    this.formData = {
      title_ar: '',
      title_en: '',
      description_ar: '',
      description_en: '',
      icon: null,
    };
    this.previewUrl = null;
    const fileInput = document.getElementById('logoUpload') as HTMLInputElement;
    if (fileInput) fileInput.value = '';
  }
}